<div class="d-flex flex-wrap container">
  <div class="container-capped-sm">
    <i *ngIf="!isMainComponent" class="fa fa-link pointer ml-1" [copy]="link"></i>
    <app-payment-check></app-payment-check>

    <div class="container-capped-sm" *ngIf="seekerJob?.Payments?.length">
      <h6 class="text-center">
        <div *ngIf="seekerJob.Payments.length>1">لیست اقساط حق‌الزحمه کاریابی</div>
        <div *ngIf="seekerJob.Payments.length==1">حق‌الزحمه کاریابی</div>
      </h6>
      <table class="table table-bordered table-striped table-hover table-condensed table-sm">
        <thead>
          <tr>
            <th>تاریخ</th>
            <th>مبلغ</th>
            <th>وضعیت</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let payment of seekerJob.Payments" [class.f-green]="payment.Status==PaymentStatus.Paid"
            [class.f-red]="overdue(payment)">
            <td>{{payment.PaymentDate|pdate:'[yyyy]/[mm]/[dd]'}}</td>
            <td [ngSwitch]="payment.payerType">{{payment.Amount|number}} تومان
              <span *ngSwitchCase="PayerType.Employer"> *</span>
              <span *ngSwitchCase="PayerType.Karyar"> </span>
            </td>
            <td [ngSwitch]="payment.Status">
              <div *ngSwitchCase="PaymentStatus.Pending">
                <div *ngIf="overdue(payment)"><i class="fa fa-spinner fa-spin"></i> پرداخت نشده</div>
                <i *ngIf="!overdue(payment)" class="fa fa-clock"></i>

              </div>
              <div class="f-green" *ngSwitchCase="PaymentStatus.Paid">
                <i class="fa fa-check"></i> پرداخت شده
              </div>
              <div *ngSwitchCase="PaymentStatus.Failed">!</div>
              <div *ngSwitchDefault>
                <i class="fa fa-asterisk"></i> جدید
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <app-karpasha-payment *ngIf="PendingPayments?.[0]?.Amount" type="agent-service"
        [amount]="PendingPayments[0].Amount" [data]="{seekerJobId:seekerJob.Id}">
        <div class="p-1 d-flex align-items-center">
          <button *ngIf="isOperator" class="btn btn-sm btn-secondary" (confirm)="removePayments()">حذف پرداخت
            نشده‌ها</button>
          <button class="btn btn-sm btn-primary mr-auto" #payButton>
            {{PendingPayments.length>1?'پرداخت یک قسط':'پرداخت و تسویه'}}</button>
        </div>
      </app-karpasha-payment>
    </div>

    <div [class.border-top]="seekerJob?.Payments?.length" class="mt-2 pt-1"
      *ngIf="(isOperator || !seekerJob) && paymentCalculator">
      <h6 class="text-center">
        <div>محاسبه‌ی حق‌الزحمه کاریابی</div>
      </h6>
      <div class="d-flex align-items-center mb-1">
        <span>حقوق ماهانه:</span>
        <div class="mx-2">
          <input type="number" [(ngModel)]="paymentCalculator.salary" />
        </div>
        <span>تومان</span>
      </div>
      <div class="d-flex align-items-center mb-1">
        <span>مدت قرارداد کاری:</span>
        <div class="mx-2">
          <input type="number" [(ngModel)]="paymentCalculator.month" style="width: 70px;" />
        </div>
        <span>ماه (0: پروژه‌ای/روزمزد)</span>
      </div>
      <!-- <div class="d-flex align-items-center mb-1">
      <span>حق‌الزحمه کاریابی:</span>
      <div class="mx-2">
        <div class="input">{{paymentCalculator.total|number}}</div>
      </div>
      <span>تومان</span>
    </div> -->
      <div class="d-flex align-items-center mb-1">
        <span>تعداد اقساط:</span>
        <div class="mx-2">
          <input type="number" [(ngModel)]="paymentCalculator.count" style="width: 70px;" />
        </div>
        <span>قسط</span>
      </div>
      <div class="d-flex align-items-center mb-1">
        <span>تاریخ اولین قسط:</span>
        <div class="mx-2">
          <app-calendar name="calc-date" [(ngModel)]="paymentCalculator.date"></app-calendar>
        </div>
      </div>
      <div class="d-flex align-items-center mb-1">
        <span>بیعانه:</span>
        <div class="mx-2">
          <input type="number" [(ngModel)]="paymentCalculator.deposit" />
        </div>
        <span>تومان</span>
      </div>

      <div class="fs-sm">
        <div class="btn btn-link fs-sm f-blue pointer" (click)="showHelp=!showHelp">قانون و روش محاسبه‌ی حق‌الزحمه
          کاریابی
        </div>
        <div class="border p-1" style="background-color: #CEECF5;" *ngIf="showHelp">
          <div class="mb-1 border-bottom">
            <div class="fw-bold">برای قرارداد‌های مدت‌دار</div>
            <span>(</span>
            <span class="f-green">حقوق تا پایه حقوق</span>
            <span> × </span>
            <span class="f-green">50%</span>
            <span> + </span>
            <span class="f-green">اختلاف پایه حقوق تا حقوق</span>
            <span> × </span>
            <span class="f-green">30%</span>
            <span>) × </span>
            <span class="f-green">مدت قرارداد</span>
            <span> / </span>
            <span class="f-green">12</span>
          </div>
          <div>
            <div class="fw-bold">برای قرارداد‌های پروژه‌ای و روزمزد</div>
            <span class="f-green">مبلغ کل پرداختی توسط کارفرما</span>
            <span> × </span>
            <span class="f-green">8%</span>
          </div>
        </div>
      </div>

      <div>
        <div class="kp-card mx-0" *ngIf="paymentCalculator.payments?.length">
          <h6>پرداخت‌ها</h6>
          <table class="table table-bordered table-striped table-hover table-condensed table-sm">
            <thead>
              <tr>
                <th>تاریخ</th>
                <th>مبلغ</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let payment of paymentCalculator.paymentsTable">
                <td class="fw-bold" *ngIf="payment._title">{{payment._title}}</td>
                <td *ngIf="!payment._title">{{payment.PaymentDate|pdate:'[yyyy]/[mm]/[dd]'}}</td>
                <td>{{payment.Amount|number}} تومان</td>
              </tr>
            </tbody>
          </table>
          <ng-container *ngIf="seekerJob && isOperator">
            <div>
              <label>پرداخت توسط:</label>
              <select [(ngModel)]="paymentCalculator.payerType">
                <option [value]="PayerType.Seeker">کارجو</option>
                <option [value]="PayerType.Employer">کارفرما</option>
              </select>
            </div>
            <button class="btn btn-sm btn-primary mt-2" (click)="savePayments()">افزودن پرداخت‌ها</button>
          </ng-container>
        </div>
      </div>
    </div>

  </div>